import { getEnvironmentKey } from './environment'
// The server redirects read this file too, so it is JSON.
import rootstechEventIds from './rootstech-event-ids.json'

/** Returns the RootsTech event id for this environment. Update the prod id in the JSON file each year. */
export function getRootstechEventId(): string {
  return rootstechEventIds[getEnvironmentKey()]
}
